const INITIAL_TOPUP_SEARCH = {
  name: "",
  categoryCode: "",
};

export { INITIAL_TOPUP_SEARCH };
